import { useEffect } from 'react';
import { Events } from '@taxdown/piccolo-web';
import EventService from 'Services/events';

const useEvents = (): void => {
  useEffect(() => {
    const onButtonEvent = (event: CustomEvent): void => {
      EventService.sendButtonPressed(event.detail);
    };
    window.addEventListener(Events.BUTTON_PRESSED, onButtonEvent as EventListener);
    return () => {
      window.removeEventListener(Events.BUTTON_PRESSED, onButtonEvent as EventListener);
    };
  }, []);
};

export default useEvents;
